import type { FC } from "react";
import { useEffect } from "react";
import ObservationBundleBloc from "src/state/ObservationBundleBloc/ObservationBundleBloc";
import { useBloc } from "src/state/state";
import DataHub from "src/ui/components/DataHub/DataHub";
import LabResultGroupTable from "src/ui/components/LabResultGroupTable";
import { Pad } from "src/ui/styled/Pad";

const UserLabResults: FC = () => {
  const [{ observationBundles }, { loadObservationBundles }] = useBloc(
    ObservationBundleBloc
  );

  const observationBundlesLimited = observationBundles?.slice(0, 20);

  useEffect(() => {
    void loadObservationBundles();
  }, []);

  return (
    <Pad>
      {/* Data Hub */}
      <DataHub />

      <nine-spacer s="lg" />
      <nine-spacer s="xs" />

      {/* List lab results */}
      <LabResultGroupTable observationBundles={observationBundlesLimited} />
    </Pad>
  );
};

export default UserLabResults;
